import CellHero from "../components/CellHero";
import CellFocus from "../components/CellFocus";
import CellPathwayNav from "../components/CellPathwayNav";
import CellLeadership from "../components/CellLeadership";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { Link } from "react-router-dom";

export default function TextileEngineeringCellPage() {
  return (
    <main className="min-h-screen">
      <CellHero
        name="Textile Engineering Cell"
        tagline="Machine Optimization, Automation, and Engineering-Driven Efficiency"
        description="The Textile Engineering Cell drives innovation at the intersection of machinery, process design, and automation feasibility. It ensures that every engineering decision is grounded in data, validated under production conditions, and scalable across factory groups."
        icon="ri-settings-3-line"
      />

      <CellFocus
        focus={[
          "Machine optimization & process engineering",
          "Automation feasibility studies",
          "Technical specification development",
          "Engineering-driven efficiency gains",
        ]}
        description="From looms to finishing lines, this cell focuses on the hardware and process architecture that determines a factory's technical ceiling. Engineers identify bottlenecks, model automation scenarios, and build the technical foundations for scale-up."
      />

      <CellLeadership
        chiefCatalyst={{
          name: "Engr. Md. Shamsuzzaman",
          designation: "Vice President, BKMEA; Managing Director, Micro Fibre Group",
        }}
        moderators={[
          {
            name: "Kajmir Mahmud",
            designation: "Director, Southwest Composite Ltd.",
          },
        ]}
      />

      {/* Related Programmes */}
      <section className="bg-tie-navy py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-8 md:mb-12">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-white/10 border border-white/20 mb-4 md:mb-5">
                  <span className="text-xs font-semibold text-white/80 uppercase tracking-wider">
                    / Related Programmes
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                  Where Engineering Meets Innovation
                </h2>
              </div>
            </ScrollReveal>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {[
                { name: "PIIC", desc: "Factory-embedded Innovation Circles with engineering-focused problem solving", route: "/piic" },
                { name: "PTIM", desc: "Test-before-scale validation for automation and process changes", route: "/ptim" },
                { name: "Training", desc: "FSD / PSD certifications for engineering professionals", route: "/training" },
                { name: "Experts", desc: "Access to 150+ textile engineering specialists on demand", route: "/experts" },
              ].map((prog, index) => (
                <ScrollReveal key={prog.name} delay={index * 100}>
                  <Link to={prog.route} className="group block p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                    <h3 className="text-base md:text-lg font-semibold text-white mb-2">{prog.name}</h3>
                    <p className="text-sm text-white/60">{prog.desc}</p>
                    <span className="inline-flex items-center mt-3 text-sm font-medium text-tie-teal-light group-hover:text-tie-teal transition-colors">
                      Learn more <i className="ri-arrow-right-line ml-1.5 text-xs group-hover:translate-x-1 transition-transform" />
                    </span>
                  </Link>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CellPathwayNav />
    </main>
  );
}